// ApiRoutes.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingHome from "../Components/LandingPage/LandingHome";
import InfoPage from "../Components/InfoPages/InfoPage";
import AccessLabPage from "../Components/AccessLab/AccessLabPage";
import ProfilePage from "../Components/Profile/ProfilePage";
import AuthenticatedApp from "../Components/AppShell/AuthenticatedApp";
import FeedPage from "../Components/AppShell/FeedPage";
import ChatPage from "../Components/AppShell/ChatPage";
import RivalryPage from "../Components/AppShell/RivalryPage";
import TeamsPage from "../Components/AppShell/TeamsPage";

export default function ApiRoutes(){
    return (
        <Router>
            <Routes>
                <Route path="/" element={<LandingHome />} />
                <Route path="/info/:slug" element={<InfoPage />} />
                <Route path="/access-lab" element={<AccessLabPage />} />
                <Route path="/profile" element={<ProfilePage />} />
                <Route path="/app" element={<AuthenticatedApp />}>
                    <Route index element={<FeedPage />} />
                    <Route path="chat" element={<ChatPage />} />
                    <Route path="rivalry" element={<RivalryPage />} />
                    <Route path="teams" element={<TeamsPage />} />
                    <Route path="profile" element={<ProfilePage />} />
                </Route>
                <Route path="*" element={<LandingHome />} />
            </Routes>
        </Router>
    )
}

/* Previous application routes preserved for later reactivation.
import React, { useContext } from "react";
import { BrowserRouter as Router,Routes, Route, Outlet, Navigate} from 'react-router-dom';
import AboutHome from "../Components/AboutPage/AboutHome";
import Appsub from "../Containers/Appsub";
import Content from "../Components/Others/Contents";
import EmailConfirmation from "../Components/SignComponents/EmailConfirmation";
import HomeUserProfileDetail from "../Components/Profiles/HomeUserProfileDetail";
import Login from "../Components/Others/Login";
import LandingHome from "../Components/LandingPage/LandingHome";
import NotFound from "../Components/PageLayout/NotFound";
import Sign from "../Components/SignComponents/Sign";
import SignUpBuffer from "../Components/SignComponents/SignUpBuffer";
import UploadVideo from "../Components/Others/Uploadvideo";
import CommunityGuidelines from "../ConformitiesPolicies/CommunityGuide";
import CookiesPolicy from "../ConformitiesPolicies/CookiesPolicies";
import CopyrightPolicy from "../ConformitiesPolicies/Copyright";
import UserDataDeletion from "../ConformitiesPolicies/UserDataDelete";
import TermsAndConditions from "../ConformitiesPolicies/ThemConditions";
import PrivacyPolicy from "../ConformitiesPolicies/Privacy";
import Recruiter from "../Containers/Recruiter";
import Talents from "../Containers/Talents";
import FeedbackHome from "../Containers/FeedbackHome";
import ChatHome from "../Components/Chats/ChatHome";
import HomeReferal from "../Components/Referals/HomeReferal";
import HomeUserProfileView from "../Components/Profiles/HomeUserProfileView";
import CompleteProfile from "../Utils/CompleteProfile";
import ReferralReport from "../micromanagement/ReferralReport";
import ForgotPassword from "../Components/SignComponents/ForgotPassword";
import Logout from "../Components/SignComponents/Logout";
import SimpleLogin from "../Components/Others/SimpleLogin";
import ProtectedPage from "../Components/Others/ProtectedPage";
import ApiContext from "../Components/globalStore/ApiContext";

const ProtecedRoutes = () =>{
    const user = useContext(ApiContext).apiData[0];
    return user ? <Outlet /> : <Navigate to="/welcome" />
}

// ... original <Routes> structure ...
*/
